/**
 * @author Peter
 * @email [hoangvanlam9988@gmail.com]
 * @create date 2022-07-13 09:41:13
 * @modify date 2022-07-13 09:41:13
 * @desc [description]
 */

import styled from "styled-components";

export const Container = styled.div`
  [type="radio"] {
    display: none;
  }

  #slider {
    height: 55vw;
    position: relative;
    perspective: 1000px;
    transform-style: preserve-3d;
  }

  #slider label {
    margin: auto;
    width: 800px;
    height: 1080px;
    position: absolute;
    left: 0;
    right: 0;
    cursor: pointer;
    transition: transform 0.4s ease;
  }

  /* Slider Functionality */

  /* Active Slide */
  #s1:checked ~ #slide1,
  #s2:checked ~ #slide2,
  #s3:checked ~ #slide3,
  #s4:checked ~ #slide4,
  #s5:checked ~ #slide5 {
    border: 0.75px solid #a7a7a7;
    transform: translate3d(0%, 0, 0px);
  }

  /* Next Slide */
  #s1:checked ~ #slide2,
  #s2:checked ~ #slide3,
  #s3:checked ~ #slide4,
  #s4:checked ~ #slide5,
  #s5:checked ~ #slide1 {
    border: 0.75px solid #a7a7a7;
    transform: translate3d(15%, 0, -1px);
  }

  /* Next to Next Slide */
  #s1:checked ~ #slide3,
  #s2:checked ~ #slide4,
  #s3:checked ~ #slide5,
  #s4:checked ~ #slide1,
  #s5:checked ~ #slide2 {
    border: 0.75px solid #a7a7a7;
    transform: translate3d(30%, 0, -2.5px);
  }

  /* Previous to Previous Slide */
  #s1:checked ~ #slide4,
  #s2:checked ~ #slide5,
  #s3:checked ~ #slide1,
  #s4:checked ~ #slide2,
  #s5:checked ~ #slide3 {
    border: 0.75px solid #a7a7a7;
    transform: translate3d(-30%, 0, -2.5px);
  }

  /* Previous Slide */
  #s1:checked ~ #slide5,
  #s2:checked ~ #slide1,
  #s3:checked ~ #slide2,
  #s4:checked ~ #slide3,
  #s5:checked ~ #slide4 {
    border: 0.75px solid #a7a7a7;
    transform: translate3d(-15%, 0, -1px);
  }

  #slide1 {
    background: linear-gradient(180deg, #f8f2fe 0%, rgba(233, 249, 241, 0) 100%),
      #ffffff;
  }
  #slide2 {
    background: linear-gradient(180deg, #fff9ef 0%, rgba(233, 249, 241, 0) 100%),
      #ffffff;
  }
  #slide3 {
    background: linear-gradient(180deg, #e9f9f1 0%, rgba(233, 249, 241, 0) 100%),
      #ffffff;
  }

  /* Check width of Slide */
  #s3:checked ~ #slide1 {
    transform: translate(-320px, 0);
  }

  #s3:checked ~ #slide2 {
    transform: translate(-160px, 0);
  }

  #s3:checked ~ #slide3 {
    transform: translate3d(0%, 0, 2px);
  }

  #s1:checked ~ #slide1 {
    transform: translate3d(0%, 0, 2px);
  }

  #s1:checked ~ #slide2 {
    transform: translate3d(160px, 0, 1px);
  }

  #s1:checked ~ #slide3 {
    transform: translate3d(320px, 0, -1px);
  }
`;
